import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Box,
  TableContainer,
  Link,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment';
import { TopPresupuestosCantidad } from '../../actions/PresupuestosAction';

export default function TopPresupuestosMasAltos() {
  const [DataTop, setDataTop] = useState([]);
  const [cantidadTop, setCantidadTop] = useState(5);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    TopPresupuestosCantidad(cantidadTop).then(response => {
      const Data = response.data;
      setDataTop(Data);
    });
  }, [cantidadTop]);

  const ManejadorTextFieldTop = e => {
    if (e.target.value === '' || e.target.value < 0) {
      e.target.value = 0;
    }
    setCantidadTop(e.target.value);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between', 
        alignItems: { xs: 'flex-start', sm: 'center' },
        mb: 3,
        gap: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <AssignmentIcon sx={{ color: 'primary.main', fontSize: 28 }} />
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600,
              fontSize: { xs: '1rem', sm: '1.25rem' }
            }}
          >
            Top Presupuestos Más Altos
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <TextField
            type="number"
            onChange={ManejadorTextFieldTop}
            defaultValue={5}
            variant="outlined"
            size="small"
            label="Cantidad"
            sx={{ width: { xs: 100, sm: 120 } }}
          />
          <Link
            component={RouterLink}
            to="/presupuestosGeneral"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              textDecoration: 'none',
              fontSize: { xs: '0.875rem', sm: '1rem' }
            }}
          >
            Ver todos <ArrowForwardIcon fontSize="small" />
          </Link>
        </Box>
      </Box>

      {isMobile ? (
        // Vista de tarjetas para móvil
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {DataTop.map(presupuesto => (
            <Card key={presupuesto.presupuestO_Id} sx={{ boxShadow: 2 }}>
              <CardContent>
                <Typography variant="subtitle2" color="primary" gutterBottom>
                  {presupuesto.codpresupuesto}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Cliente:</strong> {presupuesto.cliente.nombre} {presupuesto.cliente.apellido}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Fecha:</strong> {moment(presupuesto.fechacomprobante).format('DD/MM/YYYY')}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Total:</strong> ₲{Intl.NumberFormat('es').format(presupuesto.totalpresupuesto)}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="caption" color="text.secondary">
                  Vendedor: {presupuesto.usuarioasignado}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        // Vista de tabla para desktop
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Nro. Presupuesto</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Cliente</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Fecha</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Total</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Vendedor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {DataTop.map(presupuesto => (
                <TableRow 
                  key={presupuesto.presupuestO_Id}
                  sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
                >
                  <TableCell>{presupuesto.codpresupuesto}</TableCell>
                  <TableCell>
                    {presupuesto.cliente.nombre} {presupuesto.cliente.apellido}
                  </TableCell>
                  <TableCell>
                    {moment(presupuesto.fechacomprobante).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    ₲{Intl.NumberFormat('es').format(presupuesto.totalpresupuesto)}
                  </TableCell>
                  <TableCell align="right">{presupuesto.usuarioasignado}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
